export default "__VITE_ASSET__68010626__$_?nuxt_component=async&nuxt_component_name=SvgoFreebittorrent__"